/**
 * Axios instance with httpOnly cookie authentication
 *
 * Security: Tokens stored in httpOnly cookies (XSS-protected)
 * Cookies are sent automatically with withCredentials: true
 */
import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8027') + '/api';

// Create axios instance with credentials for httpOnly cookies
export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Send httpOnly cookies automatically
});

// Response interceptor - handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as InternalAxiosRequestConfig & { _retry?: boolean };

    // If 401 and not already retried, try to refresh token
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Refresh using httpOnly cookie (sent automatically)
        await axios.post(`${API_URL}/auth/refresh`, {}, {
          withCredentials: true,
        });

        // Retry original request (new cookie is set automatically)
        return api(originalRequest);
      } catch (refreshError) {
        // Refresh failed - redirect to login
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
